// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import ElementUI from 'element-ui';
import VideoUpy from '@/components/videoUpy'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'element-ui/lib/theme-chalk/index.css';

import { WOW } from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'
//这里需要将样式用起来，
Vue.use(animated)
//创建全局实例
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 需要执行动画的元素的 class
  animateClass: 'animated', //animation.css 动画的 class
  offset: 0, // 距离可视区域多少开始执行动画
  mobile: true, // 是否在移动设备上执行动画
  live: false, // 异步加载的内容是否有效
}
)


Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.component('VideoUpy', VideoUpy)
// Vue.prototype.$message = function(msg) {
//   Element.Message({ ...msg, duration: 2000 })
// }
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js